import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'SizeFormat'})
export class SizeFormatPipe implements PipeTransform {
    public transform(value: number | undefined): string {
        if (!value) {
            return '';
        }
        const adjustedValue = (value) / 1024 / 1024;
        if (adjustedValue < 1) {
            return parseFloat((adjustedValue * 1024).toString()).toFixed(1) + 'KB';
        } else {
            return (adjustedValue).toFixed(2) + ' MB';
        }
    }
}
